'use client';

import { useEffect } from 'react';
import { usePathname } from '@/core/i18n/routing';
import { rememberAccountPath } from '@/core/utils/account-return-path';

/**
 * Remembers the last visited pages so the account back button can return there.
 * Skips the authentication steps so back never re-enters the sign-in flow.
 */
const useRememberAccountReturnPath = (): void => {
  const pathname = usePathname();

  useEffect(() => {
    rememberAccountPath(pathname);
  }, [pathname]);
};

export default useRememberAccountReturnPath;
